import React from 'react';
import { ExternalLink, BookOpen } from 'lucide-react';

const Autores = () => {
  const autores = [
    {
      name: "Luis López De Castro Alonso",
      title: "Fundador de RESET",
      role: "Estrategia y Gestión de Despachos",
      image: "https://customer-assets.emergentagent.com/job_tecnoabogado-ia/artifacts/2rsrh23e_luis.jpeg",
      bio: "Experto en transformación de despachos de abogados en empresas rentables. Autor de 5 libros sobre gestión, estrategia y derecho empresarial. Acompaña a despachos en su evolución profesional uniendo el lenguaje de la ley y el de la rentabilidad.",
      website: "https://luislopezdecastroalonso.com/",
      expertise: ["Gestión de Despachos", "Estrategia Empresarial", "Rentabilidad", "Liderazgo Legal"]
    },
    {
      name: "José Luis Vilaplana",
      title: "@tecnoabogado",
      role: "Experto en IA Jurídica y Transformación Digital",
      image: "https://customer-assets.emergentagent.com/job_tecnoabogado-ia/artifacts/hdiywy2z_AAEN%20%282%29.png",
      bio: "Abogado innovador con más de 30 años de experiencia liderando la transformación digital del sector jurídico. Fundador de Jurisciberia SL. Experto en IA aplicada al Derecho, ciberseguridad y Legal Tech. Formador y autor de referencia en innovación legal.",
      website: "https://vilaplanatecnoabogado.es/",
      expertise: ["Inteligencia Artificial", "Ciberseguridad", "Derecho Digital", "Legal Tech"]
    }
  ];

  return (
    <section id="autores" className="bg-reset-dark py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-reset-gold uppercase tracking-widest text-sm mb-4 block">
            Los expertos detrás del programa
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-white leading-tight mb-6">
            Conoce a los <span className="italic text-reset-gold">autores</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Luis López De Castro, fundador de RESET, y José Luis Vilaplana (@tecnoabogado) colaboran en este programa único que combina estrategia empresarial con inteligencia artificial aplicada al derecho.
          </p>
        </div>

        <div className="space-y-16">
          {autores.map((autor, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 items-center bg-reset-black border border-reset-gold/20 p-8 md:p-12`}
            >
              <div className="w-full md:w-2/5">
                <div className="relative aspect-square overflow-hidden">
                  <img 
                    src={autor.image}
                    alt={autor.name}
                    className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-reset-black/60 to-transparent"></div>
                </div>
              </div>

              <div className="w-full md:w-3/5 space-y-4">
                <div>
                  <h3 className="text-3xl font-semibold text-white mb-2">
                    {autor.name}
                  </h3>
                  <p className="text-reset-gold text-lg mb-1">{autor.title}</p>
                  <p className="text-gray-400">{autor.role}</p>
                </div>

                <p className="text-gray-300 leading-relaxed text-lg">
                  {autor.bio}
                </p>

                <div className="flex flex-wrap gap-2">
                  {autor.expertise.map((skill, idx) => (
                    <span 
                      key={idx}
                      className="bg-reset-gold/10 text-reset-gold px-3 py-1 text-sm border border-reset-gold/30"
                    >
                      {skill}
                    </span>
                  ))}
                </div>

                <a 
                  href={autor.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-reset-gold hover:text-reset-gold-light transition-colors mt-4"
                >
                  <ExternalLink size={18} />
                  <span>Ver perfil completo</span>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-reset-gold/10 border border-reset-gold/30 p-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <BookOpen className="text-reset-gold" size={32} />
            <h3 className="text-2xl font-semibold text-white">
              Plan Tecnoabogado IA + Programa RESET
            </h3>
          </div>
          <p className="text-gray-300 max-w-3xl mx-auto leading-relaxed">
            El <strong className="text-white">Plan Tecnoabogado IA</strong> es una evolución del exitoso <strong className="text-white">Programa RESET</strong> de Luis López De Castro, ahora potenciado con la experiencia en IA jurídica de José Luis Vilaplana. <span className="text-reset-gold">Recomendamos haber completado el primer programa RESET para aprovechar al 100% esta implementación tecnológica avanzada.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Autores;